import {Component, inject, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {MatSnackBar} from "@angular/material/snack-bar";
import {SystemManagementService} from "../../../data-access/system-management.service";
import {faDownload, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
@Component({
    selector: 'system-log-list',
    templateUrl: './system-log-list.component.html',
    styleUrls: ['../../userManagement/userRoleAddEdit/userRoleAddEdit.css'],
    standalone: false
})
export class SystemLogListComponent implements OnInit{
  router = inject(Router)
  systemService = inject(SystemManagementService)
  private _snackBar = inject(MatSnackBar)
  files: string[] = []
  iconStyle = `color: ${localStorage.getItem('primaryColor')}; margin-right: 0.5rem; flex-shrink: 1;`
  searchText = ''
  isLoadingList = false
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'System Management',
    route: 'dashboard/SystemManagement'
  }]

  ngOnInit() {
    this.isLoadingList = true
    this.systemService.listLogFiles().subscribe((response) => {
      if(response.success) {
        this.files = response.result
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
      this.isLoadingList = false
    })
  }

  readFile(filename: string) {
    this.systemService.readLogFile(filename).subscribe({
      error: () => this._snackBar.open('Unable to download the log file. Please try again.', 'Dismiss', {panelClass: ['error-snackbar']}),
      next: (response) => {
        const anchor = document.createElement('a');
        anchor.setAttribute('href', 'data:attachment/csv;charset=utf-8,' + encodeURI(response))
        anchor.setAttribute('target', '_blank')
        anchor.setAttribute('download', `${filename}.txt`)
        anchor.style.display = 'none'
        document.body.appendChild(anchor);
        anchor.click()
        document.body.removeChild(anchor);
      }
    })
  }

  protected readonly faMagnifyingGlass = faMagnifyingGlass;
  protected readonly faDownload = faDownload;
}
